import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

  constructor() {
  }

  set(key, value) {
    // all keys values r stored under a appId Key thats why getOrEmpty
    if( typeof value !== 'string') {
      value = JSON.stringify( value);
    }
    localStorage.setItem(key, value);
  }

  // setWithKey(configKey, key, value) {
  //   let appFilters = this.getOrEmpty(configKey);
  //   appFilters[configKey][key] = value;

  //   const appId = this.appConfig.getConfigParam('appId');
  //   localStorage.setItem(appId, JSON.stringify(appFilters));
  // }

  get( key) {
    let appFilters;
    try {
      appFilters = JSON.parse(localStorage.getItem(key));
    } catch (e) { }

    return appFilters;
  }

  remove(key) {
    localStorage.removeItem(key);
  }

  // getWithKey(key) {
  //   let appFilters = this.get();
  //   return appFilters ? appFilters[key] : null;
  // }

  // private getOrEmpty(key) {
  //   let appFilters = this.get();
  //   if (!appFilters) {
  //     appFilters = {};
  //     appFilters[key] = {};
  //   }

  //   return appFilters;
  // }

  // clean() {
  //   const appId = this.appConfig.getConfigParam('appId');
  //   localStorage.removeItem(appId);
  // }

  // remove(key) {
  //   // let appFilters = this.get(key);
  //   // localStorage.removeItem()
  // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/services/localStorage.service.ts